import { render, staticRenderFns } from "./router_page.vue?vue&type=template&id=3a30fb64"
import script from "./router_page.vue?vue&type=script&lang=js"
export * from "./router_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports